export default [
  {
    path: '/feedback',
    component: () => import('@/views/feedback/Feedback.vue'),
    name: 'feedback',
    meta: {
      title: 'Phản hồi',
      auth: true,
      permission: 'view-feedback-group',
    },
  },
  {
    path: '/feedback/:id',
    component: () => import('@/views/feedback/Feedback.vue'),
    name: 'feedbackDetail',
    meta: {
      title: 'Phản hồi',
      auth: true,
      permission: 'view-feedback-group',
    },
  },
  {
    path: '/teacher-feedback',
    component: () => import('@/views/feedback/TeacherFeedback.vue'),
    name: 'teacherFeedback',
    meta: {
      title: 'Phản hồi GVCN',
      auth: true,
      // permission: ''
    },
  },
  {
    path: '/teacher-feedback/:id',
    component: () => import('@/views/feedback/TeacherFeedback.vue'),
    name: 'teacherFeedbackDetail',
    meta: {
      title: 'Phản hồi GVCN',
      auth: true,
      // permission: ''
    },
  },
]
